// extracted by mini-css-extract-plugin
export default {"principal":"Principal_principal__BUfns","container":"Principal_container__h-16-"};